import type { Signal } from "@builder.io/qwik";
import { useContext } from "@builder.io/qwik";
import { CMSDataContext } from "../contexts/cms-data";
import type { TPageProps } from "../services/content/types";

export const useCMSDataSignal = () => {
    return useContext(CMSDataContext) as unknown as Signal<TPageProps>;
};

export const useCMSData = () => {
    const cmsData = useCMSDataSignal();
    return (cmsData?.value as unknown as TPageProps) || {};
};

export const useUniversalText = () => {
    const cmsData = useCMSDataSignal();
    return (cmsData?.value as unknown as TPageProps)?.UniversalText || {};
};
